import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import * as productActions from 'redux/modules/products';

import { initializeWithKey } from 'redux-form';

var _ = require('underscore');

import { translate } from 'react-i18next';

@translate(['common'])
@connect(
  state => ({
    products: state.products.data,
    error: state.products.error,
    loading: state.products.loading,
    user: state.auth.user,
  }),
  { ...productActions, initializeWithKey })

export default class ProductList extends Component {

  constructor(props) {
    super(props);
		/*this.state = {
				products:this.props.products, 
				visibleProducts:true
		}*/
  }


  componentDidMount() {
    this.props.cancelEdit();
  }


  render() {

    var { loading, t } = this.props;
    var products = [];

    //var noProductsTxt = len(this.props.products) == len(addedProducts) ? 'Vous avez ajouté tous les produits disponibles' : 'Aucun produits'

    var addedProducts = this.props.addedProducts.map(function (p) {
      return p['id']['initialValue']
    })

    _.each(this.props.products, function (p) {
      if (_.indexOf(addedProducts, p.id) == -1) {
        products.push(p);
      }
    });


    let refreshClassName = 'fa fa-refresh';
    if (loading) {
      refreshClassName = 'fa fa-refresh fa-spin';
    }

    var products_rows = [];
    var content = [];

    var self = this;

    if (products && _.size(products) > 0) {
      _.each(products, function (product) {
        products_rows.push(
          <tr key={"key" + product.id}>
            <td>{product.identification_ID}</td>
            <td>{product.localisation_adresse}</td>
            <td>{product.s_id}</td>
            <td>
              <button className="btn btn-default" type="button" onClick={() => {
                self.props.addExistingProduct(product)
              }}>
                {t('productList.add_product')}
						  </button>
            </td>
          </tr>
        );
      });

      content.push(
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>{t('modeOpe.id_ptu')}ID PTU</th>
                <th>{t('main.address')}Adresse</th>
              </tr>
            </thead>
            <tbody>
              {products_rows}
            </tbody>
          </table>
        </div>);
    } else {
      content.push(<span>{t('productList.no_products')}</span>);
    }

    var display = products.length > 0 ? 'block' : 'none';
    return (
      <div className={''} style={{ display, width: '600px', maxWidth: '100%', 'max-height': '300px', overflow: 'auto' }} >
        <Helmet title="Products" />
        {content}
      </div>
    );
  }
}